
import { Venue } from '../Venue';
export class VenueOfSite extends Venue {

  constructor(props) {
    super(props, {pageForOrgType: 'SITE'})
    this.noAdd = true
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/sites/VenueOfSite.js